import { styled, css } from "styled-components";
import theme from "styled-theming";

import { Container as GridContainer } from "style/components/Page";
import { MQ } from "style/mediaQueries";

export const Container = styled(GridContainer)`
    padding-bottom: 0;
    padding-top: 0;
    text-align: center;
`;

export const Logo = styled.img`
    height: auto;
    margin: 3.5rem 0;
    max-height: 3.5rem;
    max-width: 100%;
    width: auto;

    ${MQ.FROM_M} {
        margin: 4.375rem 0;
        max-height: 4.375rem;
    }

    ${MQ.FROM_L} {
        margin: 5.25rem 0;
        max-height: 5.25rem;
    }

    ${MQ.FROM_XL} {
        margin: 6.5625rem 0;
        max-height: 6.125rem;
    }

    ${theme("format", {
        portrait: css`
            margin: 1.75rem 0;
            max-height: 7rem;

            ${MQ.FROM_M} {
                margin: 2.1875rem 0;
                max-height: 8.75rem;
            }

            ${MQ.FROM_L} {
                margin: 2.625rem 0;
                max-height: 10.5rem;
            }

            ${MQ.FROM_XL} {
                margin: 3.5rem 0;
                max-height: 12.25rem;
            }
        `,
        square: css`
            margin: 2.1875rem 0;
            max-height: 4.375rem;

            ${MQ.FROM_M} {
                margin: 2.625rem 0;
                max-height: 6.125rem;
            }

            ${MQ.FROM_L} {
                margin: 3.5rem 0;
                max-height: 7rem;
            }

            ${MQ.FROM_XL} {
                margin: 4.375rem 0;
                max-height: 8.75rem;
            }
        `,
    })}
`;
